import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect, useSelector, shallowEqual } from "react-redux";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import ProductDescriptionTab from "../../wrappers/product/ProductDescriptionTab";
import ProductImageDescription from "../../wrappers/product/ProductImageDescription";
import ProductSuggested from "../../wrappers/product/ProductSuggested";
import TabProductEleven from "../../wrappers/product/TabProductEleven";
const Product = ({ location, product, settings }) => {
  const { pathname } = location;

  const { currentState } = useSelector(
    (state) => ({ currentState: state.productData }),
    shallowEqual
  );

  const { detailProduct } = currentState;

  return (
    <Fragment>
      {/* <MetaTags>
        <title>{settings?.ecom_title} | Product Page</title>
        <meta
          name="description"
          content={`Product page of ${settings?.ecom_title} eCommerce template.`}
        />
      </MetaTags> */}

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>
        Home
      </BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/shop"}>
        Shop
      </BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        {detailProduct?.ecom_name || detailProduct?.name}
      </BreadcrumbsItem>

      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        {/* <Breadcrumb /> */}

        {/* product description with image */}
        <ProductImageDescription
          galleryType={"rightThumb"}
          spaceTopClass="pt-100"
          spaceBottomClass="pb-100"
          // key={new Date()}
        />
        {/* <ProductSuggested
          category="kids"
          spaceTopClass="pt-100"
          spaceBottomClass="pb-100"
          sectionTitle="Suggested Products"
          bgColorClass="bg-gray-3"
          product={detailProduct}

        /> */}

        {/* <TabProductEleven
          category="kids"
          spaceTopClass="pt-100"
          spaceBottomClass="pb-100"
          sectionTitle="Suggested Products"
          bgColorClass="bg-gray-3"
        /> */}

        {/* <TabProductEleven
          category="kids"
          spaceTopClass="pt-100"
          spaceBottomClass="pb-100"
          sectionTitle="Similar Products"
        /> */}

        {/* product description tab */}
        {/* <ProductDescriptionTab
          spaceBottomClass="pb-90"
          productFullDesc={detailProduct.description}
          product={detailProduct}
        /> */}
      </LayoutOne>
    </Fragment>
  );
};

Product.propTypes = {
  location: PropTypes.object,
  product: PropTypes.object,
  settings: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const itemSlug = ownProps.match.params.slug;

  return {
    product: itemSlug,
    settings: state.settingData.ecom.basic,
  };
};

export default connect(mapStateToProps)(Product);
